<template>
	<div class="box">
		<ComNar title = "星巴克在线代点餐"></ComNar>
		<ComShopLocation></ComShopLocation>
		<div class = "goods-group-list-div">
			<van-row>
			  <van-col span="6" style="height:100%;overflow-y: auto;padding-bottom: 1.6rem;">
				  <ComGroup @clickGroup = "clickGroup" :groupId = "groupId"></ComGroup>
			  </van-col>
			  <van-col span="18">
				  <ComGoodsList @getGoodsSpec="getGoodsSpec" @changeSpecModel = "changeSpecModel"></ComGoodsList>
			  </van-col>
			</van-row>
		</div>
		
		
		<ComPayDetail></ComPayDetail>
		
		<ComSpecModel :showSpec="comShowSpec" :goodsSpec="goodsSpec" @closeSpecModel='comShowSpec = false'></ComSpecModel>
		
	</div>
</template>

<script>
	import ComShopLocation from '../components/goods/ComShopLocation.vue'
	import ComGroup from '../components/goods/ComGroup.vue'
	import ComGoodsList from '../components/goods/ComGoodsList.vue'
	import ComPayDetail from '../components/goods/ComPayDetail.vue'
	import ComSpecModel from '../components/goods/ComSpecModel.vue'
	import ComNar from '@/components/searchShop/ComNar.vue'
	import {getShopCar } from '@/request/api';
	import {Col, Row,Tag,Button } from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'goods',
		computed: mapGetters(["getGoodsList","sShop"]),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Tag.name]: Tag,
		      [Button.name]: Button,
		      [ComShopLocation.name]: ComShopLocation,
		      [ComGroup.name]: ComGroup,
		      [ComGoodsList.name]: ComGoodsList,
		      [ComPayDetail.name]: ComPayDetail,
		      [ComSpecModel.name]: ComSpecModel,
			  [ComNar.name]: ComNar,
		      
		 },
		 mounted: function() {
		    //   this.getHistoryCar();
			// this.clearGoodsList()
			  this.$nextTick(function () {
				  let box = this.$el.querySelector('.van-col--18')
			      box.addEventListener('scroll', this.onScroll)
			  })
		 },
		data(){
			return {
				comShowSpec:false,
				jumpIndex:'',
				groupId:0,
				goodsSpec:{},
				canScroll:true
			}
		},
		methods:{
			...mapMutations(['setGoodsList','clearGoodsList']),
			changeSpecModel(val){
				this.comShowSpec = val;
			},
			clickGroup(jumpIndex){
				this.jump(jumpIndex)
			},
			getGoodsSpec(goodsSpec){
				this.comShowSpec = true;
				this.goodsSpec = goodsSpec;
			},
			
			getHistoryCar(){
				getShopCar({
					location : this.sShop.lonAndLat,
					shopName : this.sShop.shopName  
				}).then(res => {
					let goodsList =[];
					if(res){
						for(let result of res){
							let specs = [];
							if(result.specItemInfoDTOS){
								for(let spec of result.specItemInfoDTOS){
									specs.push({
										specId:spec.specId,
										itemId:spec.itemId,
										itemName:spec.itemName,
										upPrice:spec.upPrice
									})
								}
							}
							goodsList.push({
								id:result.id,
								thumb:result.goodsDTO.thumb,
								officialPrice:result.goodsDTO.officialPrice,
								price:result.goodsDTO.price,
								name:result.goodsDTO.name,
								goodsId:result.goodsDTO.goodsId,
								goodsNum:result.goodsNum,
								specs:specs
							});
						}
					}
					this.setGoodsList(goodsList);
				})  
			},
			onScroll () {
				if(this.canScroll){
					let jump = this.$el.querySelectorAll('.d_jump')
					let box = this.$el.querySelector('.van-col--18')
					for(let i=0;i<jump.length;i++){
						let item = jump[i].offsetTop
						item = item-300
						if(box.scrollTop>item){
							this.groupId = i;
						}
					}
				}
			　　　 
			},
			jump (index) {
				this.canScroll = false;
				// 用 class="d_jump" 添加锚点
				let jump = this.$el.querySelectorAll('.d_jump')
				let box = this.$el.querySelector('.van-col--18')
				let total = jump[index].offsetTop;
				total = total - 300;
				let distance = box.scrollTop;
				// 平滑滚动，时长500ms，每10ms一跳，共50跳
				let step = total / 50;
				if (total > distance) {
					this.smoothDown(distance,total,step,box);
				} else {
					let newTotal = distance - total;
					step = newTotal / 50;
					this.smoothUp(distance,total,step,box);
				}
					
			},
			smoothDown (distance,total,step,box) {
				if (distance < total) {
					distance += step;
	　　　　　	 　　box.scrollTop = distance;
					this.$nextTick(() => {
						setInterval(this.smoothDown(distance,total,step,box), 100);
					});
				} else {
					box.scrollTop = total
					setTimeout(this.resetScroll, 1000)
				}
			},
			smoothUp (distance,total,step,box) {
				if (distance > total) {
					distance -= step
					box.scrollTop = distance
					this.$nextTick(() => {
						setInterval(this.smoothUp(distance,total,step,box), 100)
					});
			   } else {
					box.scrollTop = total
					setTimeout(this.resetScroll, 1000)
					
			   }
			},
			
			resetScroll(){
				this.canScroll = true;
			}
			
			

			
			
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
		background-color: #f6f6f6;
	}
	
	.goods-group-list-div {
		width: 100%;
		height: calc(100% - 135px);
		margin-top: 10px;
		background-color: #ffffff;
		overflow: hidden;
	}
	
	
	.goods-group-list-div>.van-row {
		height: 100%;
		background-color: #f7f8fa;
	}
	
	
	.goods-group-list-div .van-row .van-col--18 {
		background-color: #ffffff;
		height: 100%;
		padding: 5px;
		overflow-y: auto;
	}
	
	
	
	
</style>
